import { compose, isEmpty, propOr } from 'ramda'

export async function handleFormValidation(form, success, error) {
  try {
    await form.validate()
  } catch {
    // Do nothing
    return
  }

  try {
    return await success(true)
  } catch (e) {
    return error(e || false)
  }
}

export function handleSubmitButtonState(submitButton, isFormValid) {
  submitButton.disabled = !isFormValid
  isFormValid ? submitButton.classList.remove("is-disabled") : submitButton.classList.add("is-disabled")
}

export function isPropEmpty(prop) {
  return compose(isEmpty, propOr("", prop))
}
